import type { FetchOptions } from '@atlassian/jira-insights-common-constants/src/common/types/fetch.tsx';
import { useFetch } from '@atlassian/jira-insights-fetch/src/controllers/use-fetch/main.tsx';
import { fetchJson } from '@atlassian/jira-insights-fetch/src/services/fetch/fetch-json/index.tsx';
import type { GetNumericFieldStatisticsParams, NumericStats } from '../../common/types.tsx';
import { PACKAGE_NAME, NUMERIC_FIELD_STATISTICS_ANALYTICS_ID } from './constants.tsx';

const getNumberFieldStatistics = async ({
	customFieldId,
	query: jql,
	fetchOptions = {},
}: GetNumericFieldStatisticsParams): Promise<NumericStats> => {
	const query = new URLSearchParams({ query: jql });
	const url = `/rest/internal/list-view-chart/number/${customFieldId}?${query.toString()}`;

	return fetchJson(url, fetchOptions);
};

export const useNumberFieldStatistics = ({
	customFieldId,
	query,
}: Omit<GetNumericFieldStatisticsParams, 'fetchOptions'>) =>
	useFetch(
		{
			onFetch: async (fetchOptions: FetchOptions) =>
				getNumberFieldStatistics({
					customFieldId,
					query,
					fetchOptions,
				}),
			analyticsTracking: {
				actionSubject: `useFetch.${NUMERIC_FIELD_STATISTICS_ANALYTICS_ID}`,
				packageName: PACKAGE_NAME,
				action: 'dataFetch',
			},
			loggingKey: `${PACKAGE_NAME}.${NUMERIC_FIELD_STATISTICS_ANALYTICS_ID}`,
			isAutoFetchable: true,
		},
		[customFieldId, query],
	);
